import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import keywordPropType from '../../propTypes/keyword';

import Styles from './Title.scss';

const Title = ({ keyword, ...rest }) => {
  const { t } = useI18nContext();
  const line1 = t(`popularKeywords.title.${keyword}`);
  const line2 = t('popularKeywords.inYourArea');

  return (
    <h1 {...rest} className={Styles.Wrapper}>
      <span>{line1}</span>
      <span>{line2}</span>
    </h1>
  );
};

Title.propTypes = {
  keyword: keywordPropType.isRequired,
};

export default Title;
